(function () {
  'use strict';

  var root = document.querySelector('[data-gz-spot-drop]');
  if (!root) return;

  var dataNode = root.querySelector('[data-gz-variant-json]');
  var variants = JSON.parse(dataNode.textContent || '[]');
  var form = root.querySelector('#GzSpotDropForm');
  var idInput = form && form.querySelector('[name="id"]');
  var karatInputs = Array.prototype.slice.call(root.querySelectorAll('[name="gzsd-karat"]'));
  var lengthInputs = Array.prototype.slice.call(root.querySelectorAll('[name="gzsd-length"]'));
  var price = root.querySelector('[data-gz-price]');
  var weight = root.querySelector('[data-gz-weight]');
  var remaining = root.querySelector('[data-gz-remaining]');
  var submit = root.querySelector('[data-gz-submit]');
  var stickyContainer = root.querySelector('[data-gz-sticky-container]');
  var stickySubmit = root.querySelector('[data-gz-sticky-submit]');
  var stickyStandard = root.querySelector('[data-gz-sticky-standard]');
  var stickyMeta = root.querySelector('[data-gz-sticky-meta]');
  var error = root.querySelector('[data-gz-error]');
  var soldCta = root.querySelector('[data-gz-sold-cta]');
  var preparationNotice = root.querySelector('[data-gz-preparation]');
  var commerce = root.querySelector('[data-gz-commerce]');
  var paymentTerms = root.querySelector('shopify-payment-terms');
  var scarcity = root.querySelector('[data-gz-scarcity]');
  var partialSold = root.querySelector('[data-gz-partial-sold]');
  var unavailableCopy = root.querySelector('[data-gz-unavailable-copy]');
  var offerId = root.getAttribute('data-offer-id');
  var declaredPreparation = root.getAttribute('data-declared-preparation') === 'true';
  var current = null;
  var releaseState = 'preparation';
  var purchaseState = 'idle';
  var stickyFrame = null;
  var previewParams = new URLSearchParams(window.location.search);
  var previewStockMode = previewParams.get('gz_preview_stock') === 'exact36'
    && window.Shopify && Shopify.theme
    && String(Shopify.theme.id) === '182399107373'
    && Shopify.theme.role === 'unpublished';
  var exactPreviewInventory = {
    'GZ-6SPOT-A11-10K-16': 1,
    'GZ-6SPOT-A11-10K-18': 4,
    'GZ-6SPOT-A11-10K-20': 3,
    'GZ-6SPOT-A11-10K-22': 3,
    'GZ-6SPOT-A11-10K-24': 8,
    'GZ-6SPOT-A11-10K-26': 4,
    'GZ-6SPOT-A11-14K-18': 2,
    'GZ-6SPOT-A11-14K-20': 2,
    'GZ-6SPOT-A11-14K-22': 4,
    'GZ-6SPOT-A11-14K-24': 5
  };

  if (previewStockMode) {
    variants.forEach(function (variant) {
      if (!Object.prototype.hasOwnProperty.call(exactPreviewInventory, variant.sku)) return;
      variant.inventory = exactPreviewInventory[variant.sku];
      variant.available = variant.inventory > 0;
    });
    dataNode.textContent = JSON.stringify(variants);
    declaredPreparation = false;
    root.setAttribute('data-preview-stock-mode', 'exact36');
    var previewBadge = document.createElement('p');
    previewBadge.className = 'gzsd__preview-badge';
    previewBadge.textContent = 'Staging preview · launch quantities simulated · checkout off';
    previewBadge.setAttribute('role', 'note');
    root.appendChild(previewBadge);
  }

  function checkedValue(inputs) {
    var checked = inputs.find(function (input) { return input.checked; });
    return checked ? checked.value : '';
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (failure) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function candidate(karat, length) {
    return variants.find(function (variant) {
      return variant.karat === karat && variant.length === length;
    });
  }

  function releaseHasInventory() {
    return variants.some(function (variant) {
      return variant.available && variant.inventory > 0;
    });
  }

  function selectedIsPurchasable() {
    return !!current && current.available && current.inventory > 0;
  }

  function clearError() {
    if (!error) return;
    error.textContent = '';
    error.hidden = true;
  }

  function showError(message) {
    if (!error) return;
    error.textContent = message;
    error.hidden = false;
    error.focus({ preventScroll: true });
  }

  function syncLengthAvailability() {
    var karat = checkedValue(karatInputs);
    lengthInputs.forEach(function (input) {
      var match = candidate(karat, input.value);
      var unavailable = !match || !match.available || match.inventory <= 0;
      input.disabled = releaseState !== 'available' || unavailable;
      var state = !match ? 'not-offered' : (releaseState === 'preparation' ? 'preparing' : (unavailable ? 'sold-out' : 'available'));
      var choice = input.closest('.gzsd__choice');
      var label = choice.querySelector('label');
      var detail;
      if (state === 'not-offered') detail = 'Not offered';
      else if (state === 'preparing') detail = 'Preparing';
      else if (state === 'sold-out') detail = 'Sold out';
      else detail = match.inventory + ' left';
      choice.setAttribute('data-state', state);
      label.textContent = input.value;
      var small = document.createElement('small');
      small.textContent = detail;
      if (state === 'available') small.setAttribute('aria-label', match.inventory + (match.inventory === 1 ? ' chain available' : ' chains available'));
      label.appendChild(small);
    });

    if (releaseState !== 'available') return;
    var selectedLength = lengthInputs.find(function (input) { return input.checked && !input.disabled; });
    if (!selectedLength) {
      var firstAvailable = lengthInputs.find(function (input) { return !input.disabled; });
      var firstOffered = lengthInputs.find(function (input) { return !!candidate(karat, input.value); });
      var fallback = firstAvailable || firstOffered;
      lengthInputs.forEach(function (input) { input.checked = input === fallback; });
    }
  }

  function syncVariantUrl() {
    if (!current || !window.history || !window.history.replaceState) return;
    var next = new URL(window.location.href);
    next.searchParams.set('variant', current.id);
    window.history.replaceState({ gzSpotDropVariant: current.id }, '', next.pathname + next.search + next.hash);
  }

  function submitShouldBeDisabled() {
    return !selectedIsPurchasable() || purchaseState !== 'idle';
  }

  function syncButtonState() {
    if (!submit) return;
    var disabled = submitShouldBeDisabled();
    if (submit.disabled !== disabled) submit.disabled = disabled;
    var label = 'CHOOSE OPTIONS';
    if (purchaseState === 'adding') label = 'ADDING…';
    else if (purchaseState === 'added') label = 'ADDED';
    else if (selectedIsPurchasable()) label = 'SECURE YOUR CHAIN';
    submit.querySelector('.button-text').textContent = label;

    if (stickySubmit) {
      stickySubmit.disabled = purchaseState !== 'idle';
      stickySubmit.hidden = releaseState !== 'available';
      stickySubmit.querySelector('.button-text').textContent = selectedIsPurchasable() ? label : 'CHOOSE OPTIONS';
    }
  }

  function syncStickyVisibility() {
    if (!stickyContainer || !form) return;
    var mobile = window.innerWidth <= 900;
    var visibleAction = releaseState === 'sold' ? soldCta : submit;
    var primaryActionHasPassed = !!visibleAction && visibleAction.getBoundingClientRect().bottom < 0;
    stickyContainer.hidden = !mobile || releaseState === 'preparation' || !primaryActionHasPassed;
  }

  function scheduleStickyVisibility() {
    if (stickyFrame) return;
    stickyFrame = window.requestAnimationFrame(function () {
      stickyFrame = null;
      syncStickyVisibility();
    });
  }

  function render(options) {
    options = options || {};
    var releaseAvailable = releaseHasInventory();
    releaseState = releaseAvailable ? 'available' : (declaredPreparation ? 'preparation' : 'sold');
    root.setAttribute('data-release-state', releaseState);

    karatInputs.forEach(function (input) { input.disabled = releaseState !== 'available'; });
    syncLengthAvailability();
    current = candidate(checkedValue(karatInputs), checkedValue(lengthInputs));
    var purchasable = selectedIsPurchasable();

    if (preparationNotice) preparationNotice.hidden = releaseState !== 'preparation';
    if (commerce) commerce.hidden = releaseState !== 'available';
    if (soldCta) soldCta.hidden = releaseState !== 'sold';
    if (stickyStandard) stickyStandard.hidden = releaseState !== 'sold';
    if (scarcity) {
      scarcity.textContent = releaseState === 'preparation'
        ? '36 chains reserved for this release.'
        : (releaseState === 'sold' ? 'This 36-chain release is sold out.' : 'Only 36 available in this release.');
    }
    if (partialSold) {
      var selectedKarat = checkedValue(karatInputs);
      var hasSoldOption = variants.some(function (variant) {
        return variant.karat === selectedKarat && (!variant.available || variant.inventory <= 0);
      });
      var missingLengths = lengthInputs.filter(function (input) {
        return !candidate(selectedKarat, input.value);
      }).map(function (input) { return input.value; });
      var shouldShowFallback = releaseState === 'available' && (hasSoldOption || missingLengths.length > 0);
      partialSold.hidden = !shouldShowFallback;
      if (unavailableCopy && shouldShowFallback) {
        if (hasSoldOption && missingLengths.length > 0) {
          unavailableCopy.textContent = 'Some options are sold out or not offered in ' + selectedKarat + '. Restock may take 1–2 months.';
        } else if (hasSoldOption) {
          unavailableCopy.textContent = 'One or more ' + selectedKarat + ' lengths are sold out — restock may take 1–2 months.';
        } else {
          unavailableCopy.textContent = missingLengths.join(' and ') + ' are not offered in ' + selectedKarat + ' in this release.';
        }
      }
    }

    if (current) {
      if (price) price.textContent = formatMoney(current.price);
      if (weight) weight.textContent = current.weight + ' g';
      if (remaining) {
        remaining.textContent = purchasable
          ? (current.inventory === 1 ? 'Only 1 chain remains in this option.' : current.inventory + ' chains remain in this option.')
          : 'Choose an available karat and length.';
        remaining.classList.toggle('gzsd__sold-message', !purchasable);
      }
      if (idInput) idInput.value = current.id;
      if (paymentTerms) paymentTerms.setAttribute('variant-id', current.id);
      if (stickyMeta) stickyMeta.textContent = current.karat + ' · ' + current.length + ' · ' + formatMoney(current.price);
      if (options.updateUrl) syncVariantUrl();
    }

    syncButtonState();
    syncStickyVisibility();
  }

  function cookie(name) {
    var prefix = name + '=';
    return document.cookie.split(';').map(function (part) { return part.trim(); }).filter(function (part) { return part.indexOf(prefix) === 0; }).map(function (part) { return decodeURIComponent(part.slice(prefix.length)); })[0] || '';
  }

  function safeStorageGet(key) {
    try { return window.localStorage.getItem(key) || ''; } catch (failure) { return ''; }
  }

  function safeStorageSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (failure) { /* storage can be blocked */ }
  }

  function clickId() {
    var params = new URLSearchParams(window.location.search);
    var supplied = params.get('goldzenn_click_id') || params.get('gz_click_id') || '';
    var existing = safeStorageGet('gz_click_id');
    var generated = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : ('gz-' + Date.now() + '-' + Math.random().toString(16).slice(2));
    var value = supplied || existing || generated;
    safeStorageSet('gz_click_id', value);
    return value;
  }

  function attributionAttributes() {
    var params = new URLSearchParams(window.location.search);
    var fbclid = params.get('fbclid') || safeStorageGet('gz_fbclid');
    var fbc = cookie('_fbc') || safeStorageGet('gz_fbc');
    if (!fbc && fbclid) {
      var arrival = safeStorageGet('gz_fbclid_arrival') || String(Date.now());
      safeStorageSet('gz_fbclid_arrival', arrival);
      fbc = 'fb.1.' + arrival + '.' + fbclid;
      safeStorageSet('gz_fbc', fbc);
    }
    var attrs = {
      'Promotional Offer ID': offerId,
      'GOLDZENN Click ID': clickId(),
      'fbclid': fbclid,
      '_fbc': fbc,
      '_fbp': cookie('_fbp'),
      'Discount Rejection Status': 'NO_DISCOUNTS_ALLOWED'
    };
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (name) {
      var supplied = params.get(name);
      if (supplied) safeStorageSet('gz_' + name, supplied);
      attrs[name] = supplied || safeStorageGet('gz_' + name);
    });
    if (params.get('fbclid')) safeStorageSet('gz_fbclid', params.get('fbclid'));
    Object.keys(attrs).forEach(function (key) { if (!attrs[key]) delete attrs[key]; });
    return attrs;
  }

  function attributionProperties() {
    var attrs = attributionAttributes();
    var properties = {};
    Object.keys(attrs).forEach(function (key) {
      properties['_Attribution ' + key] = attrs[key];
    });
    return properties;
  }

  function persistAttribution() {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attributionAttributes() })
    }).then(function (response) {
      if (!response.ok) throw new Error('Attribution storage failed');
      return response.json();
    });
  }

  function parseAddFailure(response) {
    return response.json().catch(function () { return {}; }).then(function (body) {
      var failure = new Error(body.description || 'We could not add this chain. Please refresh and try again.');
      failure.status = response.status;
      throw failure;
    });
  }

  function addPayload(variant) {
    var properties = attributionProperties();
    Object.assign(properties, {
      '_Exchange-Only Policy Acknowledged': 'Yes — higher-value exchanges only; no cash refunds',
      '_Estimated Weight': variant.weight + ' g',
      '_Offer ID': offerId,
      '_Weight Adjustment Rule': 'Refund lighter; invoice heavier for every variance of at least 0.1 g',
      '_Discount Rejection Status': 'NO_DISCOUNTS_ALLOWED'
    });
    return {
      items: [{
        id: Number(variant.id),
        quantity: 1,
        properties: properties
      }]
    };
  }

  function addCurrent() {
    if (purchaseState !== 'idle') return;
    if (!selectedIsPurchasable()) {
      showError('Choose an available karat and length before continuing.');
      return;
    }
    if (previewStockMode) {
      showError('Preview mode: selection is active, but cart checkout remains disabled until launch.');
      return;
    }

    var selected = current;
    purchaseState = 'adding';
    clearError();
    syncButtonState();

    var attributionPromise = persistAttribution().catch(function () {
      return null;
    });
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(addPayload(selected))
    }).then(function (response) {
      if (!response.ok) return parseAddFailure(response);
      return response.json();
    }).then(function () {
      return attributionPromise;
    }).then(function () {
      purchaseState = 'added';
      syncButtonState();
      window.location.assign('/checkout');
    }).catch(function (failure) {
      purchaseState = 'idle';
      if (failure.status === 422) {
        selected.available = false;
        selected.inventory = 0;
        render({ updateUrl: true });
      } else {
        syncButtonState();
      }
      var customerMessage = failure.status
        ? failure.message
        : 'We could not add this chain. Check your connection and try again.';
      showError(customerMessage || 'We could not add this chain. Please refresh and try again.');
    });
  }

  function focusOptions() {
    var target = karatInputs.find(function (input) { return input.checked && !input.disabled; }) || karatInputs.find(function (input) { return !input.disabled; });
    var field = root.querySelector('.gzsd__field');
    if (field) field.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (target) window.setTimeout(function () { target.focus({ preventScroll: true }); }, 350);
  }

  function initializeGallery() {
    var mainImage = root.querySelector('[data-gz-gallery-open] img');
    var mainButton = root.querySelector('[data-gz-gallery-open]');
    var caption = root.querySelector('[data-gz-gallery-caption]');
    var status = root.querySelector('[data-gz-gallery-status]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gz-gallery-thumb]'));
    var previous = root.querySelector('[data-gz-gallery-prev]');
    var next = root.querySelector('[data-gz-gallery-next]');
    var dialog = root.querySelector('[data-gz-gallery-dialog]');
    var dialogImage = root.querySelector('[data-gz-gallery-dialog-image]');
    var close = root.querySelector('[data-gz-gallery-close]');
    if (!mainImage || !mainButton) return;

    var currentIndex = 0;
    var swipeHandled = false;
    var pointerStart = null;

    function selectView(index) {
      currentIndex = (index + thumbs.length) % thumbs.length;
      var thumb = thumbs[currentIndex];
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = thumb.getAttribute('data-image-src');
      mainImage.alt = thumb.getAttribute('data-image-alt') || '';
      if (caption) caption.textContent = thumb.getAttribute('data-image-caption') || '';
      if (status) status.textContent = 'View ' + (currentIndex + 1) + ' of ' + thumbs.length;
      thumbs.forEach(function (item) { item.setAttribute('aria-pressed', item === thumb ? 'true' : 'false'); });
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () { selectView(index); });
    });
    if (previous) previous.addEventListener('click', function () { selectView(currentIndex - 1); });
    if (next) next.addEventListener('click', function () { selectView(currentIndex + 1); });

    mainButton.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
      pointerStart = { x: event.clientX, y: event.clientY };
      swipeHandled = false;
    });
    mainButton.addEventListener('pointerup', function (event) {
      if (!pointerStart) return;
      var deltaX = event.clientX - pointerStart.x;
      var deltaY = event.clientY - pointerStart.y;
      pointerStart = null;
      if (Math.abs(deltaX) < 44 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.2) return;
      swipeHandled = true;
      selectView(currentIndex + (deltaX < 0 ? 1 : -1));
    });
    mainButton.addEventListener('pointercancel', function () { pointerStart = null; });

    mainButton.addEventListener('click', function (event) {
      if (swipeHandled) {
        event.preventDefault();
        swipeHandled = false;
        return;
      }
      if (!dialog || !dialogImage) return;
      dialogImage.src = mainImage.currentSrc || mainImage.src;
      dialogImage.alt = mainImage.alt;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    });
    if (close) close.addEventListener('click', function () { if (dialog.open) dialog.close(); });
    if (dialog) dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
  }

  function initializeFaq() {
    var items = Array.prototype.slice.call(root.querySelectorAll('.gzsd__details details'));
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  karatInputs.concat(lengthInputs).forEach(function (input) {
    input.addEventListener('change', function () {
      purchaseState = 'idle';
      clearError();
      render({ updateUrl: true });
    });
  });
  if (form) form.addEventListener('submit', function (event) { event.preventDefault(); addCurrent(); });
  if (stickySubmit) stickySubmit.addEventListener('click', function () {
    if (selectedIsPurchasable()) addCurrent();
    else focusOptions();
  });

  if (submit && window.MutationObserver) {
    new MutationObserver(function () { syncButtonState(); }).observe(submit, { attributes: true, attributeFilter: ['disabled'] });
  }
  window.addEventListener('scroll', scheduleStickyVisibility, { passive: true });
  window.addEventListener('resize', scheduleStickyVisibility);
  window.addEventListener('pageshow', function () { render(); });

  initializeGallery();
  initializeFaq();
  render();
  persistAttribution().catch(function () { /* attribution is best-effort until a real order readback */ });
}());
